<template>
  <div id="Supervisor">
    <nav class="topnav navbar navbar-expand shadow navbar-light bg-white" id="sidenavAccordion">
      <router-link to="/supervisor" class="navbar-brand d-sm-block">
        <img :src="client.logo" style="height: 30px" alt class="mr-1" />
        <!-- {{ client.shortName }} -->
      </router-link>

      <button @click="showSideShow" class="btn btn-icon btn-transparent-dark order-1 order-lg-0 mr-lg-2" id="sidebarToggle">
        <i class="fas fa-bars"></i>
      </button>

      <!-- right memu -->
      <ul class="navbar-nav align-items-center ml-auto">
        <!-- mobile menu -->
        <li class="nav-item dropdown no-caret mr-3 mobileMenu">
          <a class="btn btn-icon btn-transparent-dark dropdown-toggle" id="navbarDropdownUserImage" href="javascript:void(0);" role="button" data-toggle="dropdown" aria-haspopup="true" aria-expanded="false">
            <div class="d-inline d-md-none font-weight-500">
              <i class="fas fa-bars"></i>
            </div>
          </a>
          <div class="dropdown-menu dropdown-menu-right border-0 shadow animated--fade-in-up" aria-labelledby="navbarDropdownUserImage">
            <router-link :to="{ name: 'HomeSupervisor' }" class="dropdown-item">
              <div class="dropdown-item-icon">
                <i class="fas fa-home"></i>
              </div>
              Home
            </router-link>

            <router-link :to="{ name: 'CreateTicketSupervisor' }" class="dropdown-item">
              <div class="dropdown-item-icon">
                <i class="fas fa-book"></i>
              </div>
              Create a Ticket
            </router-link>

            <router-link to="/supervisor/tickets/open" class="dropdown-item">
              <div class="dropdown-item-icon">
                <i class="fa fa-stop text-danger"></i>
              </div>
              Open
            </router-link>

            <router-link to="/supervisor/tickets/escalated" class="dropdown-item">
              <div class="dropdown-item-icon">
                <i class="fa fa-stop text-warning"></i>
              </div>
              Escalated
            </router-link>

            <router-link to="/supervisor/tickets/closed" class="dropdown-item">
              <div class="dropdown-item-icon">
                <i class="fa fa-stop text-success"></i>
              </div>
              Closed
            </router-link>
          </div>
        </li>

        <!-- auth user -->
        <li class="nav-item dropdown no-caret mr-1 dropdown-user">
          <a class="btn btn-icon btn-transparent-dark dropdown-toggle" id="navbarDropdownUserImage" href="javascript:void(0);" role="button" data-toggle="dropdown" aria-haspopup="true" aria-expanded="false">
            <img class="img-fluid" :src="authUser.photo" style="width: 60px" />
          </a>
          <div class="dropdown-menu dropdown-menu-right border-0 shadow animated--fade-in-up" aria-labelledby="navbarDropdownUserImage">
            <h6 class="dropdown-header d-flex align-items-center">
              <img class="dropdown-user-img" :src="authUser.photo" />
              <div class="dropdown-user-details">
                <div class="dropdown-user-details-name">{{ authUser.name }}</div>
                <div class="dropdown-user-details-email">{{ authUser.email }}</div>
                <div class="dropdown-user-details-email">{{ client.supervisorLabel }} ({{ authUser.roleName }})</div>
              </div>
            </h6>
            <div class="dropdown-divider"></div>
            <!-- <a class="dropdown-item" href="#!">
              <div class="dropdown-item-icon">
                <i data-feather="settings"></i>
              </div>Account
            </a>-->
            <router-link class="dropdown-item" :to="{ name: 'UserProfileSupervisor' }" style="cursor: pointer">
              <div class="dropdown-item-icon">
                <i data-feather="log-out"></i>
              </div>
              Profile
            </router-link>

            <!-- Logout menu -->
            <Logout type="menu"></Logout>
          </div>
        </li>
      </ul>
    </nav>

    <div id="layoutSidenav">
      <div id="layoutSidenav_nav">
        <nav class="sidenav shadow-right sidenav-light">
          <div class="sidenav-menu">
            <div class="nav accordion" id="accordionSidenav">
              <div class="sidenav-menu-heading">Core</div>

              <a class="nav-link" href="javascript:void(0);" data-toggle="collapse" data-target="#collapseTickets" aria-expanded="false" aria-controls="collapseTickets">
                <div class="nav-link-icon">
                  <i class="fas fa-headset"></i>
                </div>
                My {{ client.topCategoryLabel }}
                <div class="sidenav-collapse-arrow">
                  <i class="fas fa-angle-down"></i>
                </div>
              </a>
              <div class="collapse show" id="collapseTickets" data-parent="#accordionSidenav">
                <nav class="sidenav-menu-nested nav accordion" id="accordionSidenavPages">
                  <router-link :to="{ name: 'TicketsSupervisor', params: { status: 'open' } }" class="nav-link">Open</router-link>
                  <router-link :to="{ name: 'TicketsSupervisor', params: { status: 'escalated' } }" class="nav-link">Escalated</router-link>
                  <router-link :to="{ name: 'TicketsSupervisor', params: { status: 'closed' } }" class="nav-link">Closed</router-link>
                  <router-link :to="{ name: 'TicketsSupervisor', params: { status: 'all' } }" class="nav-link">All</router-link>
                </nav>
              </div>

              <router-link :to="{ name: 'CreateTicketSupervisor' }" class="nav-link collapsed" data-toggle="collapse" data-target="#collapseDashboards" aria-expanded="false" aria-controls="collapseDashboards">
                <div class="nav-link-icon">
                  <i class="fas fa-chart-line"></i>
                </div>
                Create a Ticket
              </router-link>
              <router-link :to="{ name: 'MyTicketsSupervisor' }" class="nav-link collapsed" data-toggle="collapse" data-target="#collapseDashboards" aria-expanded="false" aria-controls="collapseDashboards">
                <div class="nav-link-icon">
                  <i class="fas fa-chart-line"></i>
                </div>
                My Tickets
              </router-link>
            </div>
          </div>
          <div class="sidenav-footer">
            <div class="sidenav-footer-content">
              <div class="sidenav-footer-subtitle">Logged in as:</div>
              <div class="sidenav-footer-title">{{ authUser.name }}</div>
              <!-- Logout link -->
              <Logout type="link"></Logout>
            </div>
          </div>
        </nav>
      </div>

      <div id="layoutSidenav_content">
        <!-- main content -->

        <router-view />

        <!-- footer -->
        <footer class="footer mt-auto footer-light">
          <div class="container-fluid">
            <div class="row">
              <div class="col-md-6 small">{{ copyright }}</div>
              <div class="col-md-6 text-md-right small">
                Powered by
                <a href="https://coregrade.co" target="_blank">Coregrade</a>
              </div>
            </div>
          </div>
        </footer>
        <!-- footer -->
      </div>
    </div>
  </div>
</template>

<script>
import Logout from "@/components/Logout";
import brand from "../helper/brand";

export default {
  name: "Supervisor",

  mounted() {
    this.$store.dispatch("getClient");
  },

  methods: {
    showSideShow() {
      let body = document.body;
      this.sideMenuDisplayStatus = !this.sideMenuDisplayStatus;
      if (!this.sideMenuDisplayStatus) {
        body.classList.add("sidenav-toggled");
      } else {
        body.classList.remove("sidenav-toggled");
      }
    },

    searchForm() {
      this.$router.push({
        name: "Search",
        params: { query: this.searchQuery },
      });
      this.searchQuery = "";
      this.searchFormStatus = false;
    },
  },

  computed: {
    client() {
      let client = this.$store.state.client;
      if (client.name == "") {
        this.$router.push({ name: "AccountNotFound" });
      }
      return client;
    },

    authUser() {
      return this.$store.state.authUser;
    },

    copyright() {
      let d = new Date();
      return `Copyright ©${d.getFullYear()} ${this.$store.state.client.shortName}`;
    },
  },

  components: {
    Logout,
  },

  /*  updated() {
    brand.headerGradient(this.client.color, this.client.color2);
  } */
};
</script>

<style >
@import "https://cdn.jsdelivr.net/npm/animate.css@3.5.1";
/* body {
  padding-top: 100px;
} */
/* .dropdown-item {
  cursor: pointer;
} */
.page-header-subtitle {
  margin-left: 10px !important;
}
@media (max-width: 576px) {
  .desktopMenu {
    display: none;
  }
}
@media (min-width: 576px) {
  .mobileMenu {
    display: none;
  }
}
#layoutSidenav #layoutSidenav_content {
  margin-left: 0;
}
</style>
